import { applyRuntimeClients } from "@/config/applyRuntimeClients";
import { loadRuntimeConfig } from "@/config/runtimeConfig";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

export async function bootstrapApp(): Promise<void> {
  await loadRuntimeConfig();
  applyRuntimeClients();

  await import("@/businessLogicRegistry");
  await import("@/i18n");

  const [{ ConfigWrapper }, { ThemeProvider }, { PWAReloadPrompt }] =
    await Promise.all([
      import("@/components/ConfigWrapper"),
      import("@/context/ThemeContext"),
      import("@/components/PWAReloadPrompt"),
    ]);

  await import("@/styles/index.css");

  const root = document.getElementById("root");
  if (!root) {
    throw new Error("Root element not found");
  }

  createRoot(root).render(
    <StrictMode>
      <ThemeProvider>
        <ConfigWrapper />
        <PWAReloadPrompt />
      </ThemeProvider>
    </StrictMode>
  );
}
